// src/components/FileTreeSidebar.jsx — Reusable file-tree sidebar
import React, { useState } from 'react';

const defaultTree = [
  {
    id: 1, name: 'strategy', type: 'folder', open: true,
    children: [
      { id: 2, name: 'market_analysis.md', type: 'file' },
      { id: 3, name: 'gtm_plans', type: 'folder', open: false, children: [
        { id: 4, name: 'q3_2026.md', type: 'file' },
      ]},
      { id: 5, name: 'financial_models.xlsx', type: 'file' },
    ],
  },
  {
    id: 6, name: 'competitors', type: 'folder', open: true,
    children: [
      { id: 7, name: 'rival_landscape.md', type: 'file' },
    ],
  },
  { id: 8, name: 'notes.txt', type: 'file' },
];

function FileTreeSidebar({ tree: externalTree, onSelectFile }) {
  const [tree, setTree] = useState(externalTree || defaultTree);
  const [selectedFile, setSelectedFile] = useState(null);

  const toggleFolder = (id) => {
    const update = (nodes) => nodes.map(node => {
      if (node.id === id && node.type === 'folder') return { ...node, open: !node.open };
      if (node.children) return { ...node, children: update(node.children) };
      return node;
    });
    setTree(update(tree));
  };

  const renderTree = (nodes) => (
    <ul className="pl-4 space-y-0.5">
      {nodes.map((node) => (
        <li key={node.id}>
          <div
            onClick={() => {
              if (node.type === 'folder') { toggleFolder(node.id); }
              else { setSelectedFile(node.name); onSelectFile?.(node.name); }
            }}
            className={`flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg cursor-pointer transition-colors hover:bg-zinc-800 group
              ${selectedFile === node.name ? 'bg-violet-950 text-violet-300' : 'text-zinc-400'}`}
          >
            {node.type === 'folder' ? (
              <>
                <span className="text-[10px]">{node.open ? '\u25BC' : '\u25B6'}</span>
                <span className="text-amber-400 text-sm">&#128193;</span>
              </>
            ) : (
              <span className="text-sky-400 text-sm">&#128196;</span>
            )}
            <span className="truncate">{node.name}</span>
          </div>
          {node.type === 'folder' && node.open && node.children && renderTree(node.children)}
        </li>
      ))}
    </ul>
  );

  return (
    <div className="w-64 bg-zinc-900 border-r border-zinc-800 flex flex-col overflow-hidden shrink-0">
      <div className="px-5 py-3 border-b border-zinc-800 flex items-center justify-between">
        <div className="uppercase text-[10px] tracking-widest text-zinc-500 font-medium">Project Files</div>
      </div>
      <div className="flex-1 overflow-y-auto p-2 text-sm font-mono">
        {renderTree(tree)}
      </div>
      <div className="p-3 border-t border-zinc-800 text-[10px] text-zinc-500">
        {selectedFile ? `Selected: ${selectedFile}` : 'No file selected'}
      </div>
    </div>
  );
}

export default FileTreeSidebar;
